import { useState, useEffect } from 'react'
import { apiClient } from '@/services/api'
import Modal from '@/components/ui/Modal'

interface MemberInfoProps {
  item: any
  isOpen: boolean
  onClose: () => void
}

const MemberInfo = ({ item, isOpen, onClose }: MemberInfoProps) => {
  const [processing, setProcessing] = useState(true)
  const [memberId, setMemberId] = useState<string | null>(null)
  const [username, setUsername] = useState<string | null>(null)
  const [password, setPassword] = useState<string | null>(null)

  useEffect(() => {
    if (!isOpen) {
      return
    }

    const loadMembership = async () => {
      setProcessing(true)
      setMemberId(null)
      setUsername(null)
      setPassword(null)

      if (!item?.can_cancel_subscription || (!item?.club_id && !item?.order?.club_id)) {
        setProcessing(false)
        return
      }

      try {
        const result = await apiClient.get(`/order_items/${item.id}/membership/`)
        setMemberId(result.data?.member_id || null)
        setUsername(result.data?.member_username || null)
        setPassword(result.data?.member_password || null)
      } catch (err) {
        console.error(err)
      } finally {
        setProcessing(false)
      }
    }
    loadMembership()
  }, [isOpen, item])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title={!processing && memberId ? 'Member Information' : undefined}>
      {processing ? (
        <div className="flex flex-col justify-center items-center py-6">
          <div className="processing" />
        </div>
      ) : memberId ? (
        <div className="member-info">
          <div className="field">
            <span className="label">Member ID</span>
            <span className="value">{memberId}</span>
          </div>
          <div className="field">
            <span className="label">Username</span>
            <span className="value">{username}</span>
          </div>
          <div className="field">
            <span className="label">Password</span>
            <span className="value">{password}</span>
          </div>
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center py-6">
          <div className="step-title">No membership found</div>
        </div>
      )}
    </Modal>
  )
}

export default MemberInfo
